import React, { Fragment } from 'react';
import { CommonForm } from 'Components';
import { components } from 'Common';

import PreferredStart from 'Components/PreferredStart';

import { PREFERRED_START_EXTRA_TIME_OPTION } from "Constants";

const { Button, FormGroup } = components;

export class MembershipCartForm extends CommonForm {
  defaultItem = {
    quantity: '',
    preferred_start: this.props.extraTimeOption ? PREFERRED_START_EXTRA_TIME_OPTION.value : null
  }

  quantityErrors = null;

  handleChangeQuantity = ({ target }) => {
    const quantity = Number(target.value);
    this.quantityErrors = quantity < 1 ? ['quantity should be positive'] : null;
    this.changeValue('quantity', quantity);
  }

  handleChangePreferredStart = ({ target }) => {
    this.changeValue('preferred_start', target.value);
  }


  handleAddToCart = () => {
    const { itemId, addToCart } = this.props;
    const { quantity, preferred_start } = this.state.item;

    if (quantity <= 0 || !preferred_start) {
      return;
    }

    addToCart({
      item_id: itemId,
      quantity,
      options: { preferred_start }
    })
  }

  handleRemoveFromCart = () => {
    this.props.removeFromCart(this.props.itemId)
  }

  get isAvailableQuantity() {
    const { item } = this.state;
    const { availableQuantity } = this.props;

    return item.quantity > availableQuantity;
  }

  get isSoldOut() {
    const { availableQuantity } = this.props;

    return availableQuantity === 0;
  }

  render() {
    const { availableQuantity, isItemInCart, extraTimeOption } = this.props
    const { item } = this.state;

    return (
      <Fragment>
        <div className="input-group ">
          <FormGroup label="Quantity" className="no-margin" validationMessages={this.quantityErrors}>
            <input type="number" className="input-group__input"
              onChange={this.handleChangeQuantity} value={item.quantity}
              disabled={isItemInCart || this.isSoldOut} />
          </FormGroup>
          <p className="input-group__error">
            {this.isAvailableQuantity && (`Available quantity: ${availableQuantity}`)}
          </p>
          <FormGroup label="Preferred Start (not all request can be accommodated)" className="no-margin">
            <PreferredStart
              value={item.preferred_start}
              extraTimeOption={extraTimeOption}
              onChange={this.handleChangePreferredStart}
            />
          </FormGroup>
        </div>
        <div className="button-wrapper button-wrapper--less_dispance">
          {!isItemInCart && (
            <Button className="button-wrapper__button--auto-width button-wrapper__button--sm_height"
              onClick={this.handleAddToCart} disabled={!item.quantity || this.isAvailableQuantity || !item.preferred_start}>
              {!this.isSoldOut ? 'Add To Cart' : 'Sold Out'}
            </Button>
          )}
          {isItemInCart && (
            <Button
              className="button-wrapper__button--auto-width button-wrapper__button--green button-wrapper__button--sm_height"
              onClick={this.handleRemoveFromCart} >
              remove from Cart
            </Button>
          )}
        </div>
      </Fragment>
    )
  }
}
